<template>
  <div class="ticket">
    <div class="card card-default mb-4">
      <h4 class="card-header">
        #{{ ticket.iid }} - {{ ticket.title }}
      </h4>
      <div class="card-body">
        <template v-if="ticket.labels.length > 0">
          <p>
            <span v-for="(label, index) in ticket.labels" class="badge" style="margin-right:2px" :key="index"
            :class="{
              'badge-danger': label.includes('High Priority'),
              'badge-warning': label.includes('Priority'),
              'badge-info': !label.includes('Priority')
            }">{{ label }}</span>
          </p>
        </template>
        <template v-if="ticket.state === 'closed'">
          <p>
            <span class="badge badge-success">
              <span class="fa fa-check-square"></span>
              &nbsp;Completed
            </span>
          </p>
        </template>
      </div>
      <div class="card-footer">
        <strong>Submitted By: </strong>{{ username(ticket.description) }} - <i class="far fa-clock fa-fw" /> {{ ticket.created_at | date_time_format }}
        <span class="float-right">
          <router-link :to="{ path: '/tickets/' + ticket.iid }" class="btn btn-sm btn-primary">
            <span class="fa fa-search"></span>
            View
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { nl2br } from '@/util/filters'

export default {
  name: 'Ticket',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ticket () {
      return {
        ...this.object,
        labels: this.object.labels.filter(function (label) {
          return label !== 'admin-issue' && label !== 'not-a-bug'
        })
      }
    }
  },
  methods: {
    nl2br (message) {
      return nl2br(message).replace('<img', '<img style="max-height:100px;"')
    },
    username (message) {
      let message1 = message.split('\n\n- ')
      return message1[message1.length - 1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Ticket.vue